module.exports = __webpack_public_path__ + "img/no-route-map-placeholder.c3d99646.svg";